Wee.fn.make('search', {
	init: function() {
		var query = $.routes.uri().query;

		if (Object.keys(query).length > 0) {
			$('ref:searchInput').val(query.keywords)[0].focus();

			Wee.navigation.$private.enableSearchForm();
		}

		$.events.on({
			'ref:openSpecs': {
				click: function(e, el) {
					$('ref:specs').disable();

					$(el).parent()
						.find('ref:specs').enable();

					e.stopPropagation();
				}
			},
			'ref:closeSpecs': {
				click: function(e, el) {
					$(el).parent()
						.find('ref:specs').disable();

					e.stopPropagation();
					e.preventDefault();
				},
				mouseup: function(e) {
					e.stopPropagation();
				}
			}
		});

		if (Object.keys(query).length > 0) {
			$('a.pagination__link').each(function(el) {
				// If EE detects a query string on pageload, it'll append it. We don't want to add it again.
				if (el.href.indexOf('?') === -1) {
					var $el = $(el),
						queryString = Wee.routes.uri().full.match(/\?(.*)/)[0];

					$el.attr('href', $el.attr('href') + queryString);
				}
			});
		}
	}
});